// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// classnames utility
import cx from 'classnames';

// js utilities
import _, {get} from 'lodash';

// action creators for redux
import { logIn } from '../../redux/actionCreators/async/auth';

// validation
import {validate} from '../../modelValidator'; // returns an array of validation errors (empty array if none)
import {getSchema as getUserSchema} from '../../models/user';
const loginSchema = _.pick(getUserSchema(), 'email', 'password'); // this page only uses email and password

// Modal form component
import ModalForm from '../../common/components/c_ModalForm';
import TextField from '../../common/components/c_TextField';
import PasswordWithValidators from '../../common/components/f_PasswordWithValidators';
import Button from '../../common/components/Button';
// storing outside since it's fixed
const initState = {
  email: '',
  password: '',
  dirty: false
};


@connect(state => ({
  loginFormType: state.routing.locationBeforeTransitions.query.type || 'default',
  user: state.user,
  firstStatusGroup: (state.user.statusGroups || [])[0],
  labels: get(state.labels, 'Common', {}),
}))
export default class Login extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    loginFormType: PropTypes.any,
    user: PropTypes.object,
    firstStatusGroup: PropTypes.string.isRequired,
    location: PropTypes.object,
    labels: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.redirectLoggedInUser = ::this.redirectLoggedInUser;
  }

  state = _.merge({}, initState);

  componentDidMount() {
    this.redirectLoggedInUser();
  }

  componentDidUpdate(nextProps) {
    if(this.props.user !== nextProps.user) {
      this.redirectLoggedInUser();
    }
  }

  setDirty() {
    if(!this.state.dirty) {
      this.setState(_.merge({}, this.state, {
        dirty: true
      }));
    }
  }

  componentWillUnMount() {
    this.setState(_.merge({}, this.initState));
  }

  onClose = () => {
    window.location = this.props.labels.website;  // TODO: whitelabel url
  }

  redirectLoggedInUser() {
    const roles = this.props.user.roles;

    if(this.props.user.loggedIn) {
      if(roles.includes('Applicant')) {
        this.props.dispatch(push('/applicant'));
      }else if(roles.includes('Client')) {
        this.props.dispatch(push('/client'));
      }else if(roles.includes('Admin') || roles.includes('Employee')) {

        if(roles.includes('Qualifying Specialist')) {
          this.props.dispatch(push('/admin/In Process'));
        }else if(roles.includes('Placement Specialist')) {
          this.props.dispatch(push('/admin/In Process'));
        }else if(roles.includes('Relationship Manager')) {
          this.props.dispatch(push('/admin/In Process'));
        }else if(roles.includes('Client Adviser')) {
          this.props.dispatch(push('/admin/contacts'));
        }else{
          this.props.dispatch(push('/admin/In Process'));
        }

      }

    }
  }
  gotoContactUs() {
     this.props.dispatch(push('/contactus'));
  }
  logIn() {
    this.setState(_.merge({}, this.state, {
      dirty: false
    }));
    this.props.dispatch(logIn({
      email: this.state.email,
      password: this.state.password
    }));
  }

  forgotPassword() {
    this.props.dispatch(push('/forgotPassword'));
  }

  updateVal(name, event, value) {
    this.setState(_.merge(this.state, {[name]: value}));
  }

  promptText = {
    default: get(this.props, 'labels.loginText', 'Log into Account')
  }

  render() {

    return (
      <ModalForm className='login-form'
                 prompt={this.promptText[this.props.loginFormType]}
                 onClose={this.onClose}
                 dataId='Login'
                 button={{
                   label: 'Sign In',
                   onClick: ::this.logIn,
                   disabled: !!validate(this.state, loginSchema).length
                 }}
                 afterButtonText={{
                   content: 'Create/reset your password',
                   onClick: ::this.forgotPassword
                 }}>
                 <TextField className='full-width'
                            floatingLabelText='Email'
                            floatingLabelFixed={true}
                            data-id='Email'
                            onChange={this.updateVal.bind(this, 'email')}
                            onFocus={::this.setDirty}/>
                 <PasswordWithValidators value={this.state.password}
                                         onChange={this.updateVal.bind(this, 'password')}
                                         onFocus={::this.setDirty}
                                         hideWhenEmpty
                                         />
                 <div className={cx('error-message', {opaque: this.props.user.authFailed && !this.state.dirty})}>
                   Your email and/or password are incorrect
                 </div>

                {
                  this.props.location.query.hasOwnProperty('create-account')
                  &&
                  <div className='button-create-account-container'>
                    <Button
                      onClick={::this.gotoContactUs}
                      label='CREATE ACCOUNT'
                      className='button-main button-create-account'
                    />
                  </div>
                }

      </ModalForm>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/public/Login.js